/**
 *
 * Address.mixin
 *
 */

import _ from 'lodash';
import $ from 'jquery';

import { AddressEditMixin } from './AddressEdit';

export const AddressEditContainerMixin = {
  name: 'AddressEditContainerMixin',

  mixins: [AddressEditMixin],

  components: {
    'address-edit': () => import(/* webpackPreload: true */ '@/components/AddressEdit.vue'),
  },

  data: () => {
    return {
      strStudentAddressId: '',

      currentStudentAddressId: -1,

      isShowAddressEdit: false,
    };
  },

  computed: {
    c_studentAddressId() {
      if (this.strStudentAddressId) {
        return parseInt(this.strStudentAddressId);
      } else {
        return -1;
      }
    },

    c_currentAddress() {
      if (this.currentStudentAddressId > 0) {
        return _.find(
          this.mg_myAddresses,
          (myAddress) => this.currentStudentAddressId === myAddress.studentAddressId
        );
      }
    },
  },

  methods: {
    getStudentAddress() {
      this.ma_getStudentAddress();
    },

    async setAddressDefault(studentAddressId) {
      this.currentStudentAddressId = studentAddressId;
      await this.ma_makeNewAddress({
        ...this.c_currentAddress,
        isDefault: true,
      });
    },

    openAddressEdit() {
      this.isShowAddressEdit = true;
      $(this.$refs.modalAddressEdit).modal({ backdrop: true, show: true });
    },

    _closeAddressEdit() {
      $(this.$refs.modalAddressEdit).modal('hide');
    },

    closeAddressEdit() {
      this._closeAddressEdit();
    },

    modifyAddress(studentAddressId) {
      this.currentStudentAddressId = studentAddressId;
      this.openAddressEdit();
    },

    deleteAddress(studentAddressId) {
      this.ma_deleteAddress({
        studentAddressId,
      });
    },

    _AddressEditContainerMixinMounted() {
      $(this.$refs.modalAddressEdit).on('hidden.bs.modal', () => {
        this.isShowAddressEdit = false;
        this.currentStudentAddressId = -1;
      });
    },
  },

  mounted() {
    this._AddressEditContainerMixinMounted();
  },
};

export default AddressEditContainerMixin;
